if (!customElements.get('hdrey-footer-klaviyo')) {
  customElements.define(
    'hdrey-footer-klaviyo',
    class HdreyFooterKlaviyo extends HTMLElement {
      constructor() {
        super();
        this.onKlaviyoForms = this.onKlaviyoForms.bind(this);
      }

      connectedCallback() {
        window.addEventListener('klaviyoForms', this.onKlaviyoForms);
      }

      disconnectedCallback() {
        window.removeEventListener('klaviyoForms', this.onKlaviyoForms);
      }

      onKlaviyoForms(event) {
        const formId = this.dataset.klaviyoFormId;
        if (!formId) return;
        if (!event.detail || event.detail.type !== 'submit' || event.detail.formId !== formId) return;
        if (!window.Shopify?.analytics?.publish) return;

        Shopify.analytics.publish('hdrey:newsletter_signup', {
          form_id: formId,
          placement: 'footer',
        });
      }
    }
  );
}
